module.exports = __webpack_public_path__ + "img/refresh-white.eebc9f57.svg";